import { atom } from "jotai";

import { PaymentMethodDisplay } from "checkout-experience/components/payment-method/payment-method-summary-display";
import {
  PaymentMessages,
  PaymentRequirements,
} from "checkout-query-client/api/types";

import { IEncryptData } from "encrypt-value/encrypt";

export const paymentRequirementsAtom = atom<PaymentRequirements>({});

export const paymentMessagesAtom = atom<PaymentMessages>({});

export const paymentSummaryAtom = atom<PaymentMethodDisplay | undefined>(
  undefined
);

export const lpmPaymentCancelledAtom = atom<boolean>(false);

export const showCardNumberSpinnerAtom = atom<boolean>(false);

export const fetchingCardTypeAtom = atom<boolean>(false);

export const cardNumberMetaDiuAtom = atom<{
  cardNumberLength: number;
  cardNumberEncryptedStrippedAndPadded: IEncryptData;
}>();
